module.exports = {
	"about-skinny-unlimited-broadband": {
		"title": "About Skinny Fixed-line Broadband",
		"description": "Learn about the Fixed-line plan and other details.",
		"queryParam": "About Skinny Unlimited Broadband"
	},
	"getting-skinny-unlimited-broadband": {
		"title": "Getting Skinny Fixed-line Broadband",
		"description": "What you need to get started.",
		"queryParam": "Getting Skinny Unlimited Broadband"
	},
	"the-skinny-smart-modem": {
		"title": "The Skinny Smart Modem",
		"description": "Setup, operation and lots more.",
		"queryParam": "The Skinny Smart Modem"
	},
	"the-skinny-unlimited-HG659-modem": {
		"title": "The Skinny Fixed-line HG659 Modem",
		"description": "Setup, operation and lots more.",
		"queryParam": "The Skinny Unlimited HG659 Modem"
	},
	"your-account": {
		"title": "Your Account",
		"description": "Billing, payment and your details.",
		"queryParam": "Your Account"
	},
	"support": {
		"title": "Support",
		"description": "Your one stop shop for all Skinny Fixed-line Broadband support.",
		"queryParam": "Support"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/supportCategories.json
 ** module id = 1373
 ** module chunks = 0
 **/